import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class Heritage extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Our Heritage';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  nextSlide() {
    this.sliderObject.slickNext();
  }

  prevSlide() {
    this.sliderObject.slickPrev();
  }

  getSliderSettings() {
    return {
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 2500,
      cssEase: "linear",
      arrows: false,
      adaptiveHeight: true,
    };
  }

  getMobileSliderSettings() {
    return {
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 2500,
      cssEase: "linear",
      arrows: false,
      adaptiveHeight: true,
    };
  }

  render() {

    return <div className='Heritage'>
      <div className={'heritageSection desktopOnly'}>
        <div className='colsWrapper'>
          <div className='heritageCol1'>
            <div className='heritageSpacer'></div>
            <div className='hRingsWrapper'>
              <img src='https://ddw2.diamondsdirect.com/img/heritage/rings.png' />
            </div>
            <div className='quoteWrapper'>&ldquo;Buying a diamond is one of the biggest decisions of your life. We will eliminate all the confusion and pressure from this experience and guide you through this process to ensure you find the right diamond to love.&rdquo;</div>
            <div className='nameWrapper'>&mdash; Itay Berger, President</div>
          </div>
          <div className='heritageCol2'>
            <div className='pageWrapper'>
              <div className='pageTitle'>Our Heritage</div>
              <div className='pageP'>For decades, the diamond has been a symbol of love and commitment. The gift of diamond jewelry acts as a beautiful metaphor, setting your love in stone. It is timeless, steadfast and sparkles with the eternal flame of your love for one another. Love, passion, and commitment are the reasons we dedicated decades of diamond expertise into developing the Diamonds Direct experience.</div>
              <div className='pageBreak'>
                <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/iconline.svg' />
                <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/iconline_m.svg' />
              </div>
              <div className='pageP'>Diamonds Direct began as a wholesale operation, based out of both Israel and the United States, that cut and sold diamonds to jewelry stores across the country. In 1995, we opened our first showroom and completely changed the landscape of fine jewelry retail by simply eliminating the middleman and selling diamonds directly to the end customer for far less than traditional jewelry stores.</div>
              <div className='pageBreak'>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/svg/ringline.svg' />
              </div>
              <div className='pageP'>Our direct approach quickly made an impact on the jewelry industry because we paired these resources with superior guidance, education, and customer service. The Diamonds Direct experience is born from our signature approach to selection and customer service. Our mission to provide a no risk shopping environment endures today. We empower customers with diamond industry insights and products that are backed by our unmatched guarantees and warranties. We practice a personal approach while eliminating pressure and confusion during the diamond shopping experience, ensuring all customers have the opportunity to maximize their individual budget and make the best buying decision possible.</div>
              <div className='pageBreak'>
                <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/usaline.svg' />
                <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/usaline_m.svg' />
              </div>
              <div className='pageP'>As word spread, our flagship location in Charlotte, NC began pulling customers from across the southeast. Today, Diamonds Direct and our family of companies are proud to serve customers across the United States. At Diamonds Direct our motivations are simple: our passion and commitment is fueled by our desire to help you demonstrate your love for that special someone. The heart of all that we do is centered around your love, and we’re grateful you chose to celebrate that with us.</div>
            </div>
          </div>
        </div>
      </div>
      <div className={'heritageSection heritageMobileSection mobileOnly'}>
        <div className='heritageMobBanner'>
          <img src='https://ddw2.diamondsdirect.com/img/heritage/banner_m.jpg' />
        </div>
        <div className='pageWrapper'>
          <div className='pageTitle'>Our Heritage</div>
          <div className='pageP'>For decades, the diamond has been a symbol of love and commitment. The gift of diamond jewelry acts as a beautiful metaphor, setting your love in stone. It is timeless, steadfast and sparkles with the eternal flame of your love for one another. Love, passion, and commitment are the reasons we dedicated decades of diamond expertise into developing the Diamonds Direct experience.</div>
          <div className='pageBreak'>
            <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/iconline_m.svg' />
          </div>
          <div className='pageP'>Diamonds Direct began as a wholesale operation, based out of both Israel and the United States, that cut and sold diamonds to jewelry stores across the country. In 1995, we opened our first showroom and completely changed the landscape of fine jewelry retail by simply eliminating the middleman and selling diamonds directly to the end customer for far less than traditional jewelry stores.</div>
        </div>
        <div className='hRingsWrapper'>
          <img src='https://ddw2.diamondsdirect.com/img/heritage/rings_m.png' />
        </div>
        <div className='noPageWrapper'>
          <div className='pageP'>Our direct approach quickly made an impact on the jewelry industry because we paired these resources with superior guidance, education, and customer service. The Diamonds Direct experience is born from our signature approach to selection and customer service. Our mission to provide a no risk shopping environment endures today. We empower customers with diamond industry insights and products that are backed by our unmatched guarantees and warranties. We practice a personal approach while eliminating pressure and confusion during the diamond shopping experience, ensuring all customers have the opportunity to maximize their individual budget and make the best buying decision possible.</div>
          <div className='pageBreak'>
            <img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/usaline.svg' />
            <img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/heritage/svg/usaline_m.svg' />
          </div>
          <div className='pageP'>As word spread, our flagship location in Charlotte, NC began pulling customers from across the southeast. Today, Diamonds Direct and our family of companies are proud to serve customers across the United States. At Diamonds Direct our motivations are simple: our passion and commitment is fueled by our desire to help you demonstrate your love for that special someone. The heart of all that we do is centered around your love, and we’re grateful you chose to celebrate that with us.</div>
        </div>
        <div className='mobQuoteWrapper'>
          <div className='quoteWrapper'>&ldquo;Buying a diamond is one of the biggest decisions of your life. We will eliminate all the confusion and pressure from this experience and guide you through this process to ensure you find the right diamond to love.&rdquo;</div>
          <div className='nameWrapper'>&mdash; Itay Berger, President</div>
        </div>
      </div>
      <div className='awardsSection'>
        <div className='awardsTitle'>Our Awards</div>
        <div className='awardsWrapper'>
          <div className="bannerLeft" onClick={::this.prevSlide}>
            <div className="leftArrow"></div>
          </div>
          <div className="bannerRight" onClick={::this.nextSlide}>
            <div className="rightArrow"></div>
          </div>
          <div className='desktopOnly'>
            <Slider ref={(slider) => { this.sliderObject = slider; }} {...this.getSliderSettings()}>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/best.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/bestof.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/cova2018.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/fabulist.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/finalist.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/2019-Best-of.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/2020_bobs_winner-3.png' />
              </div>
            </Slider>
          </div>
          <div className='mobileOnly'>
            <Slider ref={(slider) => { this.sliderObject = slider; }} {...this.getMobileSliderSettings()}>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/best.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/bestof.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/cova2018.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/fabulist.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/mon/finalist.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/2019-Best-of.png' />
              </div>
              <div className={'awardItem rotatingBannerItem'}>
                <img src='https://ddw2.diamondsdirect.com/img/heritage/new/2020_bobs_winner-3.png' />
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>;
	}
}
export default Heritage;

function mapStateToProps(state) {
  return {

  };
}

export const HeritageContainer = connect(
  mapStateToProps,
  allActionCreators
)(Heritage);


// WEBPACK FOOTER //
// ./src/components/views/heritage/Heritage.jsx